import { Button } from "@material-ui/core";
import React from "react";
import { Box, Link, Modal } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
import DatePicker from "../../../Supporting files/DatePicker/DatePicker";
import SlidingPanel from "react-sliding-side-panel";

interface Props {
  attrName: string;
  open_status: boolean;
  value_update: Function;
}

const TravelForm: React.FC<Props> = ({
  open_status,
  value_update,
  attrName,
}) => {
  const [startdate, setStartDate] = React.useState<Date | null>(null);
  const [enddate, setEndDate] = React.useState<Date | null>(null);
  const [plan, setPlan] = React.useState("");
  const [frequency, setFrequency] = React.useState("");
  const [travelCountry, setTravelCountry] = React.useState("");
  const [travellers, setTravellers] = React.useState("");
  const [adult1, setAdult1] = React.useState("");
  const [adult2, setAdult2] = React.useState("");
  const [adult3, setAdult3] = React.useState("");
  const [adult4, setAdult4] = React.useState("");
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  // const handleChange = (event: SelectChangeEvent, attrName: string) => {
  //   if (attrName === "annualIncome") {
  //     // setAnnualIncome(event.target.value as string);
  //     // setWarnAnnualIncome(
  //     //   event.target.value.toString().length == 0 ? true : false
  //     // );
  //   }
  // };
  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  const plantype_data = [
    { key: "male", value: "Male" },
    { key: "female", value: "Female" },
  ];
  const frequency_data = [
    { key: "Single", value: "Single" },
    { key: "Indidual", value: "Indidual" },
  ];

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      backdropClicked={() => value_update(attrName, false)}>
      <div>
        {pageStatus == 2 ? null : (
          <Grid container spacing={3} alignItems="center">
            <Grid xs={6}>
              <h4 className="mb-0 mt-2">Travel Insurance</h4>
            </Grid>
          </Grid>
        )}
        {pageStatus == 2 ? null : (
          <div className="scrollable_area">
            <Grid
              container
              spacing={2}
              justifyContent="center"
              className="mb-4">
              <Grid xs={12} className="inputField">
                <RKTextField
                  class_name="inputField"
                  title="Where do you want to travel ?"
                  value={travelCountry}
                  value_update={updateMasterState}
                  attrName={setTravelCountry}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} className="inputField">
                <SelectDropdown
                  class_name="inputField"
                  title="Plan Type"
                  value={plan}
                  attrName={setPlan}
                  value_update={updateMasterState}
                  dropdown_data={plantype_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} className="inputField">
                <SelectDropdown
                  class_name="inputField"
                  title="Frequency"
                  value={frequency}
                  attrName={setFrequency}
                  value_update={updateMasterState}
                  dropdown_data={frequency_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6}>
                <DatePicker
                  class_name="inputField"
                  title="Start Date"
                  value={startdate}
                  attrName={setStartDate}
                  value_update={updateMasterState}
                  error_message="Please enter Date of Birth"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6}>
                <DatePicker
                  class_name="inputField"
                  title="End Date"
                  value={enddate}
                  attrName={setEndDate}
                  value_update={updateMasterState}
                  error_message="Please enter end Date"
                  warn_status={false}
                />
              </Grid>
              <Grid xs={12} className="inputField">
                <RKTextField
                  class_name="inputField"
                  title="Travellers"
                  value={travellers}
                  value_update={updateMasterState}
                  attrName={setTravellers}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={12} className="inputField d-none">
                <Grid container spacing={2}>
                  <Grid xs={12} textAlign="center">
                    <h6 className="popup-subheading mb-0">No Claim Bonus</h6>
                  </Grid>
                  <Grid xs={3}>
                    <RKTextField
                      class_name="inputField"
                      title="Adult 1"
                      value={adult1}
                      value_update={updateMasterState}
                      attrName={setAdult1}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={3}>
                    <RKTextField
                      class_name="inputField"
                      title="Adult 2"
                      value={adult2}
                      value_update={updateMasterState}
                      attrName={setAdult2}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={3}>
                    <RKTextField
                      class_name="inputField"
                      title="Adult 3"
                      value={adult3}
                      value_update={updateMasterState}
                      attrName={setAdult3}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={3}>
                    <RKTextField
                      class_name="inputField"
                      title="Adult 4"
                      value={adult4}
                      value_update={updateMasterState}
                      attrName={setAdult4}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        )}
        {pageStatus == 2 ? (
          <Grid container spacing={2}>
            <Grid xs={12} className="tick_animation">
              <svg
                className="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52">
                <circle
                  className="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  className="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
              <p className="quote_success">
                New Travel Insurance has been added successfully!
              </p>
            </Grid>
          </Grid>
        ) : null}
        <Grid container spacing={2}>
          {pageStatus == 2 ? null : (
            <Grid
              xs={12}
              style={{ textAlign: "center", position: "relative" }}
              className="ctaBtn">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  changePageStatus(true);
                }}>
                {pageStatus == 1 ? "Submit" : "Continue"}
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </SlidingPanel>
  );
};

export default TravelForm;
